const random = () => Math.random();
const isObject = (val) => typeof val === "object" && val !== null;
const asObjectOrDefault = (val, defaultValue) => isObject(val) ? val : defaultValue;
export {
  asObjectOrDefault,
  isObject,
  random
};
